export { default } from "./DealCard";
export { default as DealCardPlaceholder } from "./DealCardPlaceholder";
